import { render, staticRenderFns } from "./KwitansiHistory.vue?vue&type=template&id=9d147b84"
import script from "./KwitansiHistory.vue?vue&type=script&lang=js"
export * from "./KwitansiHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports